import { DashworksAuthButton } from 'ui-universal-auth';
import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const DashworksReconnectButton = ({
  buttonProps,
  label,
  metadata,
  onAuthSucceeded,
  onAuthCancelled
}) => {
  const portalId = PortalIdParser.get();
  const appId = metadata === null || metadata === void 0 ? void 0 : metadata.appId;
  if (!appId || !portalId) {
    if (enviro.isQa()) {
      console.warn('DashworksReconnectButton: Missing required props or gated', {
        appId: !!appId,
        portalId: !!portalId
      });
    }
    return null;
  }
  return /*#__PURE__*/_jsx(DashworksAuthButton, Object.assign({
    appId: appId,
    portalId: portalId,
    onComplete: onAuthSucceeded,
    onCancel: () => {
      onAuthCancelled === null || onAuthCancelled === void 0 || onAuthCancelled({
        error: new Error('Reconnection was not completed'),
        errorMessage: I18n.text('reconnectionError.commonMessage'),
        queryParams: new URLSearchParams(window.location.search).toString()
      });
    }
  }, buttonProps, {
    children: label
  }));
};